import React from "react"
import { Box } from "@mui/material"

const MuiAboutPage = () => {
  return (
    <Box sx={{ width: "100%", height: "calc(100vh - 64px)", overflow: "hidden" }}>
      <iframe
        src="/about/index.html"
        title="About"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </Box>
  )
}

export default MuiAboutPage
